<template lang="pug">
.add-item(
	:tabindex='tabIndex'
	:class='{"open":open}'
	@keydown.enter='addItem'
)
	.display-text(
		v-if='!open'
		@click='addItem'
	)
		.upload-icon
		p.label {{ options.title || "Add Item" }}

	.item-container(v-else)
		.item-wrapper
			p.label {{ options.label }}
			input(
				:placeholder='options.placeholder || "type here"'
				v-model='localValue'
				@keydown.enter='submitItem'
			)
		.button.submit(@click='submitItem') Submit
</template>

<script>
import TextInput from '@/components/form-inputs/TextInput';

export default {
	name : 'add-item',

	props : {
		options : {
			type : Object,
		},

		tabIndex : {
			type : Number,
		},
	},

	data : () => ( {
		open       : false,
		localValue : '',
	} ),

	methods : {
		addItem() {
			this.open = true;
		},

		submitItem() {
			this.$emit( 'submitted', this.localValue );
			this.open = false;
			this.localValue = '';
		},
	},

	components : {
		TextInput,
	}
};
</script>

<style lang="scss">

@keyframes slideDown {
	from {
		transform: translate( 0px, -10px );
		opacity: 0;
	}

	to {
		transform: translate( 0, 0 );
		opacity: 1;
	}
}

.add-item {

	&:not(.open) {
		border: 2px dashed $color-primary;
		border-radius: 15px;
	}

	// slide down animation is done here
	&.open {

		.item-container {
			animation: slideDown .2s 1 forwards;
		}
	}

	.display-text {
		width: 100%;
		text-align: center;
		color: $color-primary;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		// the reason why we use margin instead of using padding on the
		// .add-item is because now if users click on the edge of the
		// box it'll still click this element rather than the parent
		// element receive the click event
		margin: 8px 0;

		.upload-icon {
			position: relative;
			height: 13px;
			width: 13px;
			overflow: visible;
			margin-right: 14px;

			&::before, &::after {
				content: '';
				position: absolute;
				top: 50%;
				left: 0;
				height: 2px;
				width: 13px;
				background: $color-primary;
				border-radius: 2px;
			}

			&::before {
				transform: translateY(-50%);
			}

			&::after {
				left: 50%;
				transform: translate(-51%, -50%) rotate(90deg);
			}
		}

		p {
			color: inherit;
		}
	}

	.item-container {
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		background: white;
		border-radius: 15px;
		box-shadow: 0px 4px 24px rgba(40, 54, 63, 0.2);
		padding: 5px 5px 5px 15px;

		.item-wrapper {
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			align-items: center;

			input {
				margin-left: 15px;
			}
		}

		.submit {
			background: $color-primary;
		}
	}
}

</style>
